var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Backdrop, CircularProgress, Collapse, Divider, Drawer, Grid, IconButton, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import React, { useMemo, useState } from "react";
import { CrossIcon } from "../../../assets/images";
import { MuiIconButton } from "../../../builderPackage/components";
import { MuiBox, MuiStack } from "../../../components";
import DrawerHeader from "../../../components/atoms/DrawerHeader";
import Loader from "../../../components/molecules/loader";
import { useAppSelector } from "../../../store/hooks";
var NetPayableAmountSummaryDrawer = function (props) {
    var open = props.open, onClose = props.onClose, allJobs = props.allJobs;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isLoaderOpen = useAppSelector(function (state) { return state.common.isLoader; }).isLoaderOpen;
    var _a = useState(false), openTaxes = _a[0], setOpenTaxes = _a[1];
    var handleCloseDrawer = function () {
        onClose();
        setOpenTaxes(false);
    };
    var calculateSummary = function () {
        var _allJobs$additionalJo, _allJobs$roadTestData;
        var totalBaseAmount = 0;
        var totalDiscountAmount = 0;
        var totalTaxableAmount = 0;
        var totalTaxes = 0;
        var totalAmount = 0;
        var totalPartPrice = 0;
        var totalLabourPrice = 0;
        var decoratedTaxes = [];
        //Filtering out free service jobs to not calculate taxes for them
        var filterPaidAdditionalJobs = (allJobs === null || allJobs === void 0 || (_allJobs$additionalJo = allJobs.additionalJobs) === null || _allJobs$additionalJo === void 0 ? void 0 : _allJobs$additionalJo.filter(function (job) { return (job === null || job === void 0 ? void 0 : job.AutofillType) !== 2; })) || [];
        var allJobDetails = __spreadArray(__spreadArray(__spreadArray([], filterPaidAdditionalJobs, true), allJobs.standardJobs, true), allJobs.periodicJobs, true);
        allJobDetails.forEach(function (job) {
            var _job$SelectedPriceDet, _job$SelectedPriceDet2, _job$SelectedPriceDet3, _job$SelectedPriceDet4, _job$SelectedPriceDet5, _job$SelectedPriceDet6;
            totalBaseAmount += (job === null || job === void 0 || (_job$SelectedPriceDet = job.SelectedPriceDetails) === null || _job$SelectedPriceDet === void 0 ? void 0 : _job$SelectedPriceDet.BaseAmount) || 0;
            totalAmount += (job === null || job === void 0 || (_job$SelectedPriceDet2 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet2 === void 0 ? void 0 : _job$SelectedPriceDet2.Amount) || 0;
            totalDiscountAmount += (job === null || job === void 0 || (_job$SelectedPriceDet3 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet3 === void 0 ? void 0 : _job$SelectedPriceDet3.discountAmount) || 0;
            totalTaxableAmount += (job === null || job === void 0 || (_job$SelectedPriceDet4 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet4 === void 0 ? void 0 : _job$SelectedPriceDet4.TaxableAmount) || 0;
            job === null || job === void 0 || (_job$SelectedPriceDet5 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet5 === void 0 || (_job$SelectedPriceDet5 = _job$SelectedPriceDet5.Taxes) === null || _job$SelectedPriceDet5 === void 0 || _job$SelectedPriceDet5.forEach(function (tax) {
                totalTaxes += tax.TaxComponentAmount || 0;
            });
            job === null || job === void 0 || (_job$SelectedPriceDet6 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet6 === void 0 || (_job$SelectedPriceDet6 = _job$SelectedPriceDet6.Taxes) === null || _job$SelectedPriceDet6 === void 0 || _job$SelectedPriceDet6.forEach(function (tax) {
                var taxType = decoratedTaxes.find(function (t) { return t.type === tax.TaxComponentName; });
                if (!taxType) {
                    taxType = {
                        type: tax.TaxComponentName,
                        rates: []
                    };
                    decoratedTaxes.push(taxType);
                }
                var existingRate = taxType.rates.find(function (r) { return r.rate === tax.TaxComponentPercentage; });
                if (existingRate) {
                    var _job$SelectedPriceDet7;
                    existingRate.amount += tax.TaxComponentAmount;
                    existingRate.taxableAmount += (job === null || job === void 0 || (_job$SelectedPriceDet7 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet7 === void 0 ? void 0 : _job$SelectedPriceDet7.TaxableAmount) || 0;
                }
                else {
                    var _job$SelectedPriceDet8;
                    taxType.rates.push({
                        rate: tax.TaxComponentPercentage,
                        amount: tax.TaxComponentAmount,
                        taxableAmount: (job === null || job === void 0 || (_job$SelectedPriceDet8 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet8 === void 0 ? void 0 : _job$SelectedPriceDet8.TaxableAmount) || 0
                    });
                }
            });
        });
        allJobs === null || allJobs === void 0 || (_allJobs$roadTestData = allJobs.roadTestData) === null || _allJobs$roadTestData === void 0 || _allJobs$roadTestData.forEach(function (item) {
            totalPartPrice += parseFloat(!item.isExpanded && item.PartPrice || 0);
            totalLabourPrice += parseFloat(!item.isExpanded && item.LabourPrice || 0);
        });
        var netPayableAmount = totalAmount + totalPartPrice + totalLabourPrice;
        totalBaseAmount += totalPartPrice + totalLabourPrice;
        return {
            totalBaseAmount: totalBaseAmount,
            totalDiscountAmount: totalDiscountAmount,
            totalTaxableAmount: totalTaxableAmount,
            totalTaxes: totalTaxes,
            netPayableAmount: netPayableAmount,
            decoratedTaxes: decoratedTaxes
        };
    };
    var _b = useMemo(calculateSummary, [allJobs]), totalBaseAmount = _b.totalBaseAmount, totalDiscountAmount = _b.totalDiscountAmount, totalTaxableAmount = _b.totalTaxableAmount, totalTaxes = _b.totalTaxes, netPayableAmount = _b.netPayableAmount, decoratedTaxes = _b.decoratedTaxes;
    return /*#__PURE__*/ React.createElement(Drawer, {
        id: "translate-to-job-drawer-amount-summary",
        anchor: isDesktop ? "right" : 'bottom',
        open: open,
        onClose: handleCloseDrawer,
        sx: {
            display: {
                xs: 'block',
                sm: 'block',
                md: 'block',
                lg: 'block'
            },
            '& .MuiDrawer-paper': {
                width: {
                    xs: '100%',
                    sm: '50%',
                    md: '450px',
                    lg: '450px',
                    xl: '450px'
                },
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px'
            }
        }
    }, isDesktop && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        className: "border-bottom-custom"
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11,
        style: {
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        id: "trasnlateToJobItems",
        align: "left",
        fontWeight: "bold",
        color: "black"
    }, "Job  details")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "closeIconBtn",
        onClick: handleCloseDrawer,
        disabled: isLoaderOpen,
        style: {
            marginLeft: "7px"
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "crossIcon",
        src: CrossIcon,
        alt: "settingIcon"
    })))))), isLoaderOpen ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        padding: 2,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: '0px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Total base amount"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "total-base-amount",
        fontWeight: "bold"
    }, "\u20B9 ".concat(totalBaseAmount.toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, null, t("Total taxable amount"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "total-taxable-amount",
        fontWeight: "bold"
    }, "\u20B9 ".concat(totalTaxableAmount.toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            cursor: "pointer"
        },
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, t("Taxes")), /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, openTaxes ? /*#__PURE__*/ React.createElement(ExpandLess, null) : /*#__PURE__*/ React.createElement(ExpandMore, null)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "total-taxes",
        fontWeight: "bold"
    }, "\u20B9 ".concat(totalTaxes.toFixed(2)))), openTaxes && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Collapse, {
        in: openTaxes,
        sx: {
            mt: 1,
            bgcolor: "#f5f5f5",
            p: 2,
            borderRadius: 2
        }
    }, decoratedTaxes && (decoratedTaxes === null || decoratedTaxes === void 0 ? void 0 : decoratedTaxes.length) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, "@")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, "On")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, t("Tax amount")))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        py: 1
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            borderTop: '1.5px dashed #DEE4EB',
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: 'none'
        }
    }))), decoratedTaxes.map(function (tax, index) { /*#__PURE__*/ return React.createElement(Grid, {
        container: true,
        key: index,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, tax.type, ":")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, tax.rates.map(function (rate, i) { /*#__PURE__*/ return React.createElement(React.Fragment, {
        key: i
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB',
            my: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3'
    }, rate.rate, " %")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB',
            my: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3'
    }, "\u20B9 ", rate.taxableAmount.toFixed(2))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "right",
        sx: {
            my: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'bold'
    }, "\u20B9 ", rate.amount.toFixed(2)))); }))), decoratedTaxes.length - 1 != index && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        py: 1
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            borderTop: '1.5px dashed #DEE4EB',
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: 'none'
        }
    }))); })) : /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1
    }, /*#__PURE__*/ React.createElement(Typography, null, t("No data found"))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: "bold"
    }, t("Net payable amount"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "net-payable-amount",
        fontWeight: "bold"
    }, "\u20B9 ".concat(netPayableAmount.toFixed(2)))))))), /*#__PURE__*/ React.createElement(Backdrop, {
        sx: function (theme) { return ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 1
        }); },
        open: isLoaderOpen
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        color: "inherit"
    }))))));
};
export default NetPayableAmountSummaryDrawer;
